import { Award, Truck, ShieldCheck, Clock, Users } from "lucide-react";
import { useSEO } from "@/lib/hooks";

export default function AboutPage() {
  useSEO({ title: "À propos — Depann7", description: "Notre engagement : un service de dépannage et de remorquage rapide, sérieux et transparent en Île-de-France." });
  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">À propos</h1>
          <p className="text-ink-300 mt-2">Notre engagement envers vous</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12 space-y-6">
        <p className="text-txt-700 text-lg leading-relaxed">
          Depann7 est un service de dépannage et de remorquage de véhicules légers basé en Île-de-France.
          Depuis nos débuts, nous mettons un point d'honneur à offrir une intervention rapide, un tarif transparent
          et un accompagnement humain dans des moments souvent stressants.
        </p>
        <p className="text-txt-500 leading-relaxed">
          Notre équipe d'opérateurs et de chauffeurs sillonne quotidiennement la Seine-Saint-Denis, Paris, et
          tous les départements d'Île-de-France pour répondre aux demandes des particuliers comme des professionnels
          (garages, loueurs, VTC, assurances).
        </p>
        <div className="grid sm:grid-cols-2 gap-4 pt-4">
          <Item Icon={Clock} title="Rapidité">Intervention moyenne de 30 à 45 minutes.</Item>
          <Item Icon={Truck} title="Matériel récent">Camions plateau et matériel de levage adaptés.</Item>
          <Item Icon={ShieldCheck} title="Sécurité">Procédures rigoureuses et assurances pro.</Item>
          <Item Icon={Award} title="Transparence">Devis annoncé avant départ, pas de surprise.</Item>
          <Item Icon={Users} title="Service humain">Une équipe à votre écoute, jour et nuit.</Item>
        </div>
      </div>
    </div>
  );
}

function Item({ Icon, title, children }) {
  return (
    <div className="bg-surface-50 border border-surface-200 rounded-2xl p-5">
      <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center">
        <Icon className="text-brand" size={20} />
      </div>
      <div className="font-bold text-txt-900 mt-3">{title}</div>
      <p className="text-txt-500 text-sm mt-1">{children}</p>
    </div>
  );
}
